import React, { useEffect } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ppsiInProgressRoute } from '../routes';
import PpsiForm from '../components/PpsiForm';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import {
  getAvailableLanguages,
  getLanguage,
  getConfigs
} from '../features/app/selectors';
import usePpisRelatedToFormulaCode from '../features/PpiContainer/hooks/usePpisRelatedToFormulaCode';
import useCreatePpsi from '../features/PpsiContainer/hooks/useCreatePpsi';
import useGlobalPpis from '../features/PpiContainer/hooks/useGlobalPpis';
import useUtensils from '../features/UtensilContainer/hooks/useUtensils';
import { toJS } from '../utils/immutableUtils';
import useDishes from '../features/DishContainer/hooks/useDishes';
import copyPpsi from '../features/PpsiContainer/copy';
import { getPpsiDefaultData } from '../features/PpsiContainer/util';

import useQueryParams from '../utils/useQueryParams';
import { MARKET_GLOBAL_LANG } from '../features/app/constants';
import { Mode } from '../components/PpsiForm/constants';
import View from './views';
import useGlobalPpsi from 'features/PpsiContainer/hooks/useGlobalPpsi';
import useGlobalPublishedPpiIfs from 'features/PpsiContainer/hooks/useGlobalPublishedPpiIfs';
import useMarketDishLogo from 'features/PpsiContainer/hooks/useMarketDishLogo';
//import useProductAreas from 'features/PpsiContainer/hooks/useProductAreas';
import useProductArea from 'features/DishContainer/hooks/useProductArea';

// Hard-coded for now, could potentially be passed and query string parameter

/**
 * Clears the presentation name of the data. This allows the default name to
 * used rather than the name in english.
 * @param data
 * @returns {*}
 */
function clearPresentationName(data) {
  const dataWithoutName = _.cloneDeep(data);
  _.keys(data.info).forEach(language => {
    delete dataWithoutName.info[language].presentationName;
  });
  return dataWithoutName;
}

// TODO Refactor to PpsiCreateFromGlobalView
// This only works when copying a Global PPSI. It copies EN-IF into all
// languages for the user.
const PpsiCreateFromExistingView = () => {
  const marketLanguage = useSelector(getLanguage);
  // Need both id of PPSI and enrichment to create PPSI from in order to be able
  // to reload the view without breaking it (can't fetch PPSI based on
  // enrichment id).
  const [
    fromPpsiId,
    fromEnrichmentId,
    formulaCode,
    localPpsiCopy
  ] = useQueryParams('ppsiId', 'enrichmentId', 'formulaCode', 'localPpsiCopy');
  const copyFromLanguage =
    localPpsiCopy === 'true' ? marketLanguage : MARKET_GLOBAL_LANG;
  // Fetch PPSI to copy from
  const [fromPpsiRaw, isFetchingPpsi, fetchPpsiError] = useGlobalPpsi(
    fromPpsiId,
    {
      forceFetch: true
    }
  );
  const [isFetchingPpisRelatedToFormula] = usePpisRelatedToFormulaCode(
    formulaCode
  );
  //const [piaProductAreas] = useProductAreas();
  const [isFetching, marketDishLogo, fetchError] = useMarketDishLogo({
    forceFetch: true
  });
   const [isFetchingProductArea, productArea, fetchProductAreaError] = useProductArea({
    forceFetch: true
  });
  const [isFetchingDishes, dishes] = useDishes({ formulaCode });
  const [createPpsi, isSaving, createdPpsiId] = useCreatePpsi();
  // const [isFetchingGlobalPpis, globalPpisRaw] = useGlobalPpis();
  // const globalPpis = toJS(globalPpisRaw, []);
  const [isFetchingGlobalPpiIfs, getGlobalId] = useGlobalPublishedPpiIfs();
  const languages = useSelector(getAvailableLanguages);
  const getConfigData = useSelector(getConfigs).toJS();

  // Initiate sales area code and stoe code
  const storeLists =
    getConfigData && getConfigData.stores.map(item => item.code);
  const salesAreas =
    getConfigData && getConfigData.salesPoint.map(item => item.code);

  useEffect(() => {
    if (fromPpsiId) {
      getGlobalId(fromPpsiId);
    }
  }, [fromPpsiId]);
  // Initiate fetching of utensils
  useUtensils();
  // useGlobalPpis();

  const fromPpsi = toJS(fromPpsiRaw);
  const toDish = toJS(dishes.first());

  if (createdPpsiId) {
    return <Redirect to={ppsiInProgressRoute(createdPpsiId)} />;
  }

  if (fetchPpsiError) {
    throw fetchPpsiError;
  }

  if (
    isFetchingPpsi ||
    isFetchingPpisRelatedToFormula ||
    isFetchingDishes ||
    isFetchingGlobalPpiIfs
  ) {
    return <ProgressFullscreen open />;
  }

  // Copy PPSI data
  let enrichmentData = copyPpsi(
    fromPpsi,
    fromEnrichmentId,
    copyFromLanguage,
    languages
  );
  enrichmentData = clearPresentationName(enrichmentData);
  const defaultData = getPpsiDefaultData(languages, toDish);

  View.PpsiCreateFromExisting.visit(toDish);
  return (
    <PpsiForm
      data={{
        ...enrichmentData,
        ...(marketLanguage === copyFromLanguage || localPpsiCopy === 'true'
          ? { parentPpsiEnrichmentDataId: null }
          : '')
      }}
      defaultData={defaultData}
      isSaving={isSaving}
      onSave={createPpsi}
      dataLabels={{
        title: (data, { language }) =>
          _.get(data, `info.${language}.presentationName`)
      }}
      mode={Mode.CREATE}
      globalData={fromPpsi}
      // globalPpsis={globalPpsis}
      // globalPpis={globalPpis}
    />
  );
};

export default PpsiCreateFromExistingView;
